var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"window-banner"}},[_c('i',{staticClass:"el-icon-more-outline",attrs:{"id":"i-menu"},on:{"click":_vm.openMenu}}),_c('span',{attrs:{"id":"right-float"}},[_c('span',{attrs:{"id":"username"}},[_vm._v("欢迎您 "+_vm._s(_vm.username))]),_c('span',{attrs:{"id":"currentTime"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }